// extracted by mini-css-extract-plugin
export var addViewLink = "_6-2";
export var availabilityIcon = "_6-17";
export var availabilitySelectionIcon = "_6-16";
export var backButton = "_6-3";
export var backIcon = "_6-10";
export var conversationCount = "_6-4";
export var dragHandle = "_6-6";
export var dropdown = "_6-f";
export var dropdownIcon = "_6-8";
export var dropdownOption = "_6-7";
export var dropdownTriangle = "_6-e";
export var expand = "_6-g";
export var folder = "_6-j";
export var folderItem = "_6-d";
export var icon = "_6-9";
export var iconRow = "_6-a";
export var image = "_6-b";
export var logo = "_6-c";
export var navContainer = "_6-i";
export var navigationFooter = "_6-h";
export var pageShell = "_6-0";
export var pageShellWms = "_6-1";
export var placeholderAvailable = "_6-12";
export var placeholderBox = "_6-15";
export var placeholderBusy = "_6-14";
export var placeholderUnavailable = "_6-13";
export var profile = "_6-l";
export var profileContainer = "_6-n";
export var profileDropdown = "_6-o";
export var profileImage = "_6-m";
export var profileMain = "_6-p";
export var profileSubtitle = "_6-r";
export var profileTitle = "_6-q";
export var reorderIcon = "_6-s";
export var sentLine = "_6-v";
export var settingsHeader = "_6-t";
export var sidenavTextColor = "_6-z";
export var spamLine = "_6-u";
export var subitemWithTag = "_6-5";
export var supportItems = "_6-k";
export var teamText = "_6-11";
export var viewLine = "_6-y";
export var viewLineButton = "_6-x";
export var viewLineButtons = "_6-w";